module.exports = __webpack_public_path__ + "bg.8a0211a8.svg";